// extracted by mini-css-extract-plugin
export var legendIndicator = "_eq-1";
export var legendRight = "_eq-0";